import { defineComponent, h } from 'vue';
import { Modal } from '@/ui/components/Modal';
import { pageSubtitle } from '@/ui/components';
import { t } from '@/ui/i18n/i18n';
import { VNodeData } from 'vue/types/vnode.d';
import { Button } from '@/ui/components/Button';
import { issueCreateWithLogs } from '@/ui/pages/issue/IssueCreateWithLogs';
import { IssueRecordEditable } from '@/ui/pages/issue/issueTypes';
import { Icon } from '@/ui/components/icon/Icon';

interface CreateIssueModalProps {
  mergeAttributes?: Partial<IssueRecordEditable>;
  loading: boolean;
}

export const CreateIssueModal = defineComponent<CreateIssueModalProps>({
  name: 'CreateIssueModal',
  props: ['loading', 'mergeAttributes'],

  setup(props, context) {
    const onCreatedIssue = (data: { id: string }) => {
      context.emit('created:issue', data);
    };

    const closeModal = () => {
      context.emit('close');
    };

    const onIssueCreateClick = () => {
      context.emit('issue:click:create');
    };

    return function render() {
      return h(Modal, {
        props: {
          active: true,
          ariaRole: 'dialog',
          trapFocus: true,
          destroyOnHide: false,
          ariaModal: true,
          width: '960px',
          hasPrimaryBackgroundColor: true,
          canCancel: ['x'],
          hideClose: true,
        },
        on: { close: closeModal },
        scopedSlots: {
          actions: () => h('div',
            [
              h(Button, {
                props: { type: 'is-text', btnClass: 'mr-2 has-text-weight-semibold' },
                on: { click: closeModal },
              }, t('modal.cancel')),
              h(Button, {
                props: {
                  loading: props.loading,
                },
                on: { click: onIssueCreateClick },
              }, t('issues.create')),
            ]),
        },
      }, [
        h('header', { class: 'modal__header' },
          [
            pageSubtitle(t('issues.create')),
            h(Icon, {
              props: { icon: 'times', classes: 'modal__close' },
              nativeOn: { click: closeModal },
            }),
          ]),
        issueCreateWithLogs({
          props: { mergeAttributes: props.mergeAttributes, hideSendButton: true },
          on: { 'issue:created': onCreatedIssue },
        }),
      ]);
    };
  },
});

export function createIssueModal(data: VNodeData & { props: CreateIssueModalProps }) {
  return h(CreateIssueModal, data);
}
